<div>
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" style="background-color: inherit; ">
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle style="cursor: pointer">
            <button mat-icon-button disabled></button>
            <div style="flex: 1;">
                {{ node.name }}
            </div>
            <mat-checkbox (change)="onSelectSection($event,node)" [checked]="isSectionChecked(node)" class="checkStyle">
            </mat-checkbox>
        </mat-tree-node>

        <mat-tree-node *matTreeNodeDef="let node; when: hasChild" class="regionItem" matTreeNodePadding>
            <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
                <mat-icon class="mat-icon-rtl-mirror">
                    {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                </mat-icon>
            </button>
            <div>
                {{ node.name }}
            </div>
            <mat-checkbox (change)="onSelectRegion($event,node)" class="checkStyle"
                [indeterminate]="isRegionParcialVisible(node)" [checked]="isRegionChecked(node)">
            </mat-checkbox>
        </mat-tree-node>
    </mat-tree>

</div>